export default __webpack_public_path__ + "static/media/questionBank.99b6a4b9.svg";